export default __webpack_public_path__ + "static/media/Hellfury Wristbands.2b985a5d.jpg";